export default "__VITE_ASSET__BRRgubZS__"